import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { listProposals } from '../../../../actions/proposalActions';

// React Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

// Funcions
import { filterItems } from '../../../../maths/Functions';

// Componente
import Proposal from '../../../../components/Proposal';

const TypeSection = () => {
  const dispatch = useDispatch();
  const [type, setType] = useState('Charla');
  const [activeId, setActiveId] = useState(1);
  const btns = [
    { id: 1, type: 'Charla' },
    { id: 2, type: 'Taller' },
    { id: 3, type: 'Ciclo' },
    { id: 4, type: 'Cápsula' },
  ];

  // Global data: talks
  const proposalList = useSelector((state) => state.proposalList);
  const { loading, error, proposals } = proposalList;

  useEffect(() => {
    dispatch(listProposals());
  }, [dispatch]);

  const handleClick = (type, id) => {
    setType(type);
    setActiveId(id);
  };

  const proposalsFilter = proposals && filterItems(proposals, type);

  return (
    <section className="type section">
      <Container fluid="lg">
        <Row className="type__row">
          {btns.map((btn) => (
            <button
              key={btn.id}
              className={`main-btn ${activeId === btn.id ? 'is-active' : ''}`}
              onClick={() => handleClick(btn.type, btn.id)}
            >
              {btn.type === 'Taller'
                ? `${btn.type}es`
                : btn.type === 'Charla'
                ? `${btn.type}s`
                : `${btn.type}`}
            </button>
          ))}
        </Row>
        {loading && <p>Loading...</p>}
        {error && <p>{error}</p>}
        {proposalsFilter?.map((proposal) => (
          <Proposal key={proposal._id} {...proposal} />
        ))}
      </Container>
    </section>
  );
};

export default TypeSection;
